import type { CreateTaskScheduleDto, CreateInstantTaskDto } from "@/services/Backup/interfaces";
import { NumberRangeInclusive, PositiveNumber, ZeroOrPositiveNumber } from "@/services/FtpUser/validators/number";
import { NonEmptyString } from "@/services/FtpUser/validators/string";

type FieldValidator<T> = (value: T) => string | boolean;

type FieldRules<T extends Record<string, unknown>> = {
  [name in keyof T]: FieldValidator<T[name]>[];
};

export class CreateInstantTaskForm implements CreateInstantTaskDto {
  public type: string = '';
  public targetServerId: string = '';

  public rules: FieldRules<CreateInstantTaskDto> = {
    type: [
      NonEmptyString("Type must not be empty"),
    ],
    targetServerId: [
      NonEmptyString("Server ID must not be empty"),
    ],
  };
}

export class CreateTaskScheduledForm implements CreateTaskScheduleDto {
  public type: string = '';
  public targetServerId: string = '';
  public intervalDays: number = 1;
  public runAtHour: number = 0;
  public runAtMinute: number = 0;
  public retries: number = 0;

  public rules: FieldRules<CreateTaskScheduleDto> = {
    type: [
      NonEmptyString("Type must not be empty"),
    ],
    targetServerId: [
      NonEmptyString("Server ID must not be empty"),
    ],
    intervalDays: [
      PositiveNumber("Interval days must be a positive number"),
    ],
    runAtHour: [
      NumberRangeInclusive(0, 23, "Run at hour must be between 0 and 23"),
    ],
    runAtMinute: [
      NumberRangeInclusive(0, 59, "Run at minute must be between 0 and 59"),
    ],
    retries: [
      ZeroOrPositiveNumber("Retries must be a zero or positive number"),
    ],
  };
}
